import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from 'moment';
import * as XLSX from "xlsx";
import { almacenamientoMeli } from "./almacenamientoMeli";

function CostosAlmacenajes() {
  const { user } = useContext(AuthContext);
  const URL_COSTOS_ALMACENAJES = process.env.REACT_APP_URL_COSTOS_ALMACENAJES;
  const URL_COSTOS_ALMACENAJES_ARTICULOS = process.env.REACT_APP_URL_COSTOS_ALMACENAJES_ARTICULOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-91);
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  
  const [costosAlmacenajes, setCostosAlmacenajes] = useState([]);
  const [totalTotal, setTotalTotal] = useState(0);

    const [modalArchivo, setModalArchivo] = useState(false);
  const toggleArchivo = () => setModalArchivo(!modalArchivo);
  // Archivo leido + revision del back
  const [archivo, setArchivo] = useState(null);
  const [revisando, setRevisando] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);
    const [modalProgreso, setModalProgreso] = useState(false);
    const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;


  useMemo(() => {
    axios
      .get(`${URL_COSTOS_ALMACENAJES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCostosAlmacenajes = response.data;
        setCostosAlmacenajes(allCostosAlmacenajes);
        setComments(allCostosAlmacenajes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);



  function PDFTabla() {
    const data = comments
    .filter(
      (comment) =>
        comment.idCostosAlmacenajes.toString().includes(search)||
        comment.total.toString().includes(search)
    )
      .map((a) => {
          return [
            a.idCostosAlmacenajes,
            a.fecha,
            new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.total),
          ];
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
       const doc = new jsPDF({compressPdf: true});
       var img2 = new Image();
       img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
       doc.addImage(img2, "png", 155, 15, 45, 15);
    doc.text(`Costos Almacenajes`, 15, 20);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Total",

        ],
      ],
      body: dataPDFLimpia,
      startY: 30,
      // footStyles: {
      //       fontSize: 12,
      //       fillColor: [255,255,255],
      //       textColor: [0,0,0]
      //     },
          foot: [
        [
          "",
          "Total",
          new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(totalTotal),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`CostosAlmacenajes.pdf`);
  }

  function excel() {

    const data = comments
    .filter(
      (comment) =>
        comment.idCostosAlmacenajes.toString().includes(search)||
        comment.total.toString().includes(search)
    )
      .map((a) => {
        return {
          Numero: a.idCostosAlmacenajes,
          Fecha: a.fecha,
          Total: a.total,
        };
    });
    const dataExportExcel = Object.values(data);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "CostosAlmacenajes";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "CostosAlmacenajes",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Total",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments
    .filter(
      (comment) =>
        comment.idCostosAlmacenajes.toString().includes(search)||
        comment.total.toString().includes(search)
    )
      .map((a) => {
          return [
            a.idCostosAlmacenajes,
            a.fecha,
            new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.total),
          ];
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
       const doc = new jsPDF({compressPdf: true});
       var img2 = new Image();
       img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
       doc.addImage(img2, "png", 155, 25, 45, 15);
    doc.text(`Costos Almacenajes`, 15, 30);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Total",

        ],
      ],
      body: dataPDFLimpia,
      startY: 35,
      footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
        [
          "",
          "Total",
          new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(totalTotal),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Costos Almacenajes",
          email: mailTo,
          fileName: "CostosAlmacenajes.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Inventarios.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

 

  const headers = [
    { name: "Numero", field: "idCostosAlmacenajes", sortable: true },
    { name: "Periodo", field: "fecha", sortable: true },
    { name: "Total", field: "total", sortable: true },
    { name: "PDF", field: "PDF", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          // comment.codigo.toLowerCase().includes(search.toLowerCase()) ||
          comment.idCostosAlmacenajes.toString().includes(search)||
          comment.total.toString().includes(search)
      );
    }

     if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    let can = computedComments.map((c) => parseFloat(c.total));
    let TCan = can.reduce((t, total, index) => t + total, 0);
    setTotalTotal(TCan);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field && sorting.field != "idCostosAlmacenajes"  && sorting.field != "total") {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (sorting.field && sorting.order === "asc" && (sorting.field == "idCostosAlmacenajes")) {
      computedComments = computedComments.sort(
        (a, b) => parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (sorting.field && sorting.order === "desc" && (sorting.field == "idCostosAlmacenajes")) {
      computedComments = computedComments.sort(
        (a, b) => parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin
  ]);

    async function PDFOC(
    id,
    idCostosAlmacenajes,
    fecha,
    totalCosto
  ) {
    await axios
      .get(`${URL_COSTOS_ALMACENAJES_ARTICULOS}CostoAlmacenaje/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = allArticulosPedido
        // .sort((a, b) => (a.crearedAt < b.crearedAt ? 1 : -1))
          .map((a) => {
            return {
              articulos: a.articulos[0].SKU + " " + a.articulos[0].nombre,
              total: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        const data = dataFinal.map((a) => {
          return [
            a.articulos,
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
         const doc = new jsPDF({compressPdf: true});
       var img2 = new Image();
       img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
       doc.addImage(img2, "png", 155, 15, 45, 15);
        
        doc.setFontSize(12);
        doc.text(`Costos Almacenajes: #${idCostosAlmacenajes}`, 15, 15);
        doc.text(`Fecha: ${fecha}`, 15, 20);

        doc.autoTable({
          head: [
            [
              "Articulo",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          margin: { left: 5, right: 5 },
          startY: 30,
          foot: [
            [
              "Total",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(totalCosto),
            ],
          ],
          showFoot: "lastPage",
        });

        doc.save(`CostoAlmacenaje-${idCostosAlmacenajes}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headersAuth = {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  };
  const moneda = (n) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n);

  async function importarArchivo(event) {
    const file = event.target.files && event.target.files[0];
    setArchivo(null);
    if (!file) return;

    let leido;
    try {
      leido = almacenamientoMeli(XLSX.read(new Uint8Array(await file.arrayBuffer()), { type: "array" }));
    } catch (error) {
      Swal.fire({ icon: "error", title: "Oops...", text: error.message || "No se pudo leer el archivo" });
      return;
    }
    if (!leido || !leido.filas.length) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        html: 'No es el reporte de MeLi <b>Costos por servicio de almacenamiento</b> (hoja "Detalle").',
      });
      return;
    }

    setRevisando(true);
    try {
      const { data } = await axios.post(`${URL_COSTOS_ALMACENAJES}Archivo`, { ...leido, aplicar: false }, headersAuth);
      setArchivo({ ...leido, resumen: data });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${(error.response && error.response.data && error.response.data.message) || error.message}`,
      });
      console.log(error);
    }
    setRevisando(false);
  }

  const saveArchivo = async (event) => {
    event.preventDefault();
    const { resumen, ...leido } = archivo;
    setValidaBoton(false);
    toggleProgreso();
    try {
      const { data } = await axios.post(`${URL_COSTOS_ALMACENAJES}Archivo`, { ...leido, aplicar: true }, headersAuth);
      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Costos Almacenajes",
          detalle: `#${data.idCostosAlmacenajes} ${data.inicio} a ${data.fin} ${data.total}`,
          user: user.id,
        },
        headersAuth
      );
      Swal.fire("Good job!", "Creado con exito", `success`);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      toggleProgreso();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${(error.response && error.response.data && error.response.data.message) || error.message}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_pedidos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
              <Button
                size="sm"
                color="info"
                onClick={toggleArchivo}
                id="botonListado"
              >
                Importar Archivo
              </Button>
              
            </Col>
            
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Inventarios</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
         
          <h3 align="center">Costos Almacenajes</h3>
          <div className="row">
            <div className="col-md-10">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div> <div className="col-md-1 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
           
           
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>

          
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                  return (
                    <tr>
                      <td>{a.idCostosAlmacenajes}</td>
                      <td>{a.inicio ? `${a.inicio} a ${a.fecha}` : a.fecha}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total)}</td>
                    
                      <td>
                    <Button
                                                        size="sm"
                                                        className="btn"
                                                        color="danger"
                                                        onClick={(e) =>
                                                          PDFOC(
                                                            a._id,
                                                            a.idCostosAlmacenajes,
                                                            a.fecha,
                                                            a.total
                                                          )
                                                        }
                                                      >
                                                        <i class="far fa-file-pdf"></i>
                                                      </Button>

                      </td>
                    </tr>
                  );
                }
              )}
              <tr>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotal)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
     

      <Modal isOpen={modalArchivo} toggle={toggleArchivo}>
            <ModalHeader toggle={toggleArchivo}>
              <h4>Archivo Costos Almacenajes</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Costos por servicio de almacenamiento (MeLi)</Label>
              <Input
                required
                type="file"
                name="file"
                id="file"
                accept=".xlsx,.xls"
                onChange={(event) => importarArchivo(event)}
              />
              {revisando ? <p className="mt-3">Revisando archivo...</p> : undefined}
              {archivo ? (
                <div className="mt-3">
                  <p className="mb-1">Periodo: <b>{archivo.resumen.inicio} a {archivo.resumen.fin}</b></p>
                  <p className="mb-1">Productos: <b>{archivo.resumen.productos}</b> ({archivo.resumen.articulos} articulos)</p>
                  <p className="mb-1">Total: <b>{moneda(archivo.resumen.total)}</b></p>
                  {archivo.resumen.reemplaza.length ? (
                    <p className="mb-1 text-warning">Reemplaza lo ya cargado de ese periodo (#{archivo.resumen.reemplaza.join(", #")})</p>
                  ) : undefined}
                  {archivo.resumen.sinLigar.length ? (
                    <div className="mt-2">
                      <p className="mb-1 text-danger">No se van a guardar porque no existen en el catalogo:</p>
                      {archivo.resumen.sinLigar.map((a, i) => (
                        <p className="mb-0" key={i}>{a.sku} · {moneda(a.total)}</p>
                      ))}
                    </div>
                  ) : undefined}
                </div>
              ) : undefined}
            </ModalBody>
            <ModalFooter>
              {validaBoton && archivo && archivo.resumen.articulos > 0 ? (
              <Button size="sm" color="success" 
              onClick={saveArchivo}
              >
                Guardar
              </Button>
                ) : (
                              <Button size="sm" color="success"  disabled>
                                Guardar
                              </Button>
                            )}
            </ModalFooter>
          </Modal>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
      {loader}
    </>
  );
}

export default CostosAlmacenajes;
